import script from "./rate.vue?vue&type=script&setup=true&lang=js"
export * from "./rate.vue?vue&type=script&setup=true&lang=js"

import "./rate.vue?vue&type=style&index=0&id=5b49f7f6&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.4_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b49f7f6"]])

export default __exports__